function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import TargomoIsochroneComponent from '../../components/Map/TargomoIsochrone';
import { useSelector } from 'react-redux';
import * as turf from '@turf/turf';
import { useMap } from '../../hooks';
function TargomoIsochrone(props) {
  var _useSelector = useSelector(function (state) {
      return state.dataset;
    }),
    selected = _useSelector.selected;
  var _useSelector2 = useSelector(function (state) {
      return state.app.project.configs;
    }),
    primaryColor = _useSelector2.primaryColor;
  var _useMap = useMap(),
    map = _useMap.map;
  var item = selected.item;
  var client = new tgm.TargomoClient('westcentraleurope', 'HSMFRFRYEUSHGJZWHJQ6');
  var getPolygons = function getPolygons(source, options) {
    client.polygons.fetch([source], options).then(function (geojsonPolygons) {
      map.getSource('polygon').setData(geojsonPolygons);
      map.fitBounds(turf.bbox(geojsonPolygons), {
        padding: 20
      });
    });
  };
  var getColorPolygons = function getColorPolygons(times) {
    var colorsConfig = times.map(function (time, idx) {
      return [times[idx], primaryColor];
    });
    return colorsConfig;
  };
  var getHeightPolygons = function getHeightPolygons(travelTimes, heightFactor) {
    return [[travelTimes[0], travelTimes.length * (10 * heightFactor)], [travelTimes[travelTimes.length - 1], travelTimes.length * heightFactor]];
  };
  var removePointsStyle = function removePointsStyle() {
    map.setPaintProperty('isochronePolygons', 'fill-extrusion-height', 0);
    map.setPaintProperty('isochronePolygons', 'fill-extrusion-color', '#000000');
    map.setPaintProperty('isochronePolygons', 'fill-extrusion-opacity', 0);
  };
  var handleIsochrone = function handleIsochrone(_ref) {
    var timeValue = _ref.timeValue,
      activeTravelType = _ref.activeTravelType;
    // !!map.getLayer('isochronePolygons') && map.removeLayer('polygons122');
    // !!map.getSource('isochronePolygons') && map.removeSource('polygon');

    var travelTimes = [timeValue * 60];
    var source = {
      id: 'source',
      lng: item.geometry.coordinates[0],
      lat: item.geometry.coordinates[1]
    };
    var options = {
      travelType: activeTravelType,
      travelEdgeWeights: travelTimes,
      edgeWeight: 'time',
      srid: 4326,
      serializer: 'geojson',
      simplify: 200,
      elevation: true,
      quadrantSegments: 6,
      buffer: 0.002,
      walkSpeed: {
        speed: 5
      },
      bikeSpeed: {
        speed: 15
      }
    };
    map.setPaintProperty('isochronePolygons', 'fill-extrusion-height', {
      'property': 'time',
      'stops': getHeightPolygons(travelTimes, 2)
    });
    map.setPaintProperty('isochronePolygons', 'fill-extrusion-color', {
      'property': 'time',
      'stops': getColorPolygons(travelTimes)
    });
    map.setPaintProperty('isochronePolygons', 'fill-extrusion-opacity', .5);
    getPolygons(source, options);
  };
  return /*#__PURE__*/React.createElement(TargomoIsochroneComponent, _extends({
    handleIsochrone: handleIsochrone,
    removePointsStyle: removePointsStyle
  }, props));
}
export default TargomoIsochrone;